<template>
    <div :class="['app-auth-page', 'reg-bg']">
        <div id="components-section" data-aos="fade-left">
            <div id="sign-in-form-1">
                <div class="form-body">
                    <p
                        class="title is-3"
                        style="margin-bottom: 5px; font-weight: 700"
                    >
                        {{ $t("Verify your identity") }}
                    </p>
                    <p style="color: #000">
                        {{ $t("Select a way to recive a verification code") }}
                    </p>
                    <div class="level">
                        <div class="level-item" style="flex-direction: column">
                            <div
                                style="margin: 100px 0; width: 100%"
                                v-if="!form.doneMessage.length"
                            >
                                <div class="info">
                                    <img src="@/assets/images/mail.svg" />
                                    <p>
                                        <span
                                            :class="[
                                                { error: error },
                                                { success: !error && !loading },
                                            ]"
                                            >{{ $t("Email code to") }}</span
                                        >
                                        <br />
                                        <span class="email">{{
                                            user.email
                                        }}</span>
                                    </p>
                                </div>
                                <hr />
                                <div
                                    class="info"
                                    @click="
                                        $router.push({ name: 'verify-mobile' })
                                    "
                                >
                                    <img src="@/assets/images/smartphone.svg" />
                                    <p>
                                        <span
                                            :class="[
                                                { error: error },
                                                { success: !error && !loading },
                                            ]"
                                            >{{
                                                $t(
                                                    "Text code to number ending in"
                                                )
                                            }}</span
                                        >
                                        <br />
                                        <span class="email"
                                            >*****{{
                                                user.mobile.slice(-4)
                                            }}</span
                                        >
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div style="width: 100%">
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                            "
                        >
                            <button
                                :class="[
                                    'auth-button',
                                    { 'is-loading': loading },
                                ]"
                                @click="$router.push({ name: 'home' })"
                            >
                                {{ $t("Back") }}
                            </button>
                            <button
                                :class="[
                                    'auth-button',
                                    { 'is-loading': loading },
                                ]"
                                style="border-radius: 10px"
                                @click="$router.push({ name: 'sign-in-email' })"
                            >
                                <span>{{
                                    $t("Sign in to a different account")
                                }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { validateEmail } from "@/helpers";

export default {
    name: "ResetPassword",
    data() {
        return {
            form: {
                email: "",
                password: "",
                passwordConfirmation: "",
                doneMessage: "",
                errorMessage: "",
            },
            img: 1,
        };
    },
    created() {
        this.img = Math.floor(Math.random() * 3 + 1);
    },
    computed: {
        user() {
            return this.$store.getters.userData;
        },
    },
};
</script>

<style lang="scss" scoped>
$primary: #ffcb04;
$error: #eb6174;

::v-deep {
    input {
        border: none !important;
        border-bottom: 1px solid #ddd !important;
        box-shadow: none !important;
        border-radius: 0;
    }
}

.info {
    cursor: pointer;
    margin-top: 20px;
    display: flex;
    align-items: center;
    text-align: left;
    padding: 5px;
    transition: 0.4s;

    &:hover {
        background: #f7f7f7;
    }

    img {
        width: 60px;
        opacity: 0.5;
    }

    p {
        font-size: 14px;
        margin: 0 20px;
        color: #000;

        span.email {
            font-weight: bold;
            font-size: 16px;
        }
    }
}

.app-auth-page {
    // background: no-repeat 0 50%;
    // background-size: cover;
    min-width: 100vw;
    min-height: 100vh;
    display: flex;
    justify-content: flex-end;
    padding: 10px 30px;

    #components-section {
        width: 740px;
        z-index: 9999999;
    }

    .form-body {
        border-radius: 5px;
        margin: 10px 0;
        background-color: white;
        min-width: 500px;
        padding: 40px 50px;
        width: 500px;
        // height: 500px;
        display: inline-block;

        ::-webkit-input-placeholder {
            /* Edge */
            font-size: 14px;
        }

        :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            font-size: 14px;
        }

        ::placeholder {
            font-size: 14px;
        }

        .input-container {
            width: 100%;
            // min-width: 350px;
            margin-bottom: 60px;
        }

        .label {
            text-align: left;
        }

        .control {
            width: 100%;
            display: inline-block;
        }

        .form-gray {
            color: #9b9b9b;
            font-size: 14px;
            text-align: center;
        }

        .field {
            width: 100%;
            margin-bottom: 25px;
        }
    }

    #white-section {
        background-color: white;
        min-width: 500px;
        width: 200vw;
        height: 250px;
        transform: rotate(3deg);
        margin-left: -25px;
    }

    .banner {
        width: 414px;
        height: 200px;
        display: inline-block;
        transform: rotate(-3deg);
    }

    .image {
        width: 414px;
        margin-top: 50px;
        margin-left: calc(25% - 207px);
    }
}

.error {
    color: red;
    margin: 20px 0;
}
</style>
